<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">OSBOD Inhaallessen (coördinator)</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
			<v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details></v-text-field>
		</v-card-title>

		<v-data-table :headers="headers" :items="data" :search="search" :loading="loading">
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<v-btn depressed class="ml-2" @click="setStudentOvertakeClass()" color="inverted">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>Add Student Inhaalles
					</v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.action="{ item }">
				<v-icon @click="handleClick(item.id)">mdi-account-edit</v-icon>
			</template>
			<template v-slot:item.coordinator_approval="{ item }">
				<v-simple-checkbox
					:value="!!Number(item.coordinator_approval)"
					disabled
				></v-simple-checkbox>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import Axios from "axios";
import { API_ROOT } from "../../config";

const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "student_overtake_class_coordinator",
	data() {
		return {
			user: JSON.parse(localStorage.getItem("user") || "{}"),
			search: "",
			headers: [
				{
					text: "",
					align: "center",
					sortable: false,
					value: "action"
				},
				{ text: "Schoolyear", value: "tbl_sys_schoolyear.name" },
				{ text: "Class", value: "tbl_sys_class.name" },
				{ text: "Periode", value: "tbl_sys_periode.name" },
				{ text: "Deelkwalificatie", value: "tbl_sys_subject.name" },
				{ text: "Module", value: "tbl_teacher_subject_class.module" },
				{ text: "Student", value: "tbl_student.display_name" },
				{ text: "Omschrijving", value: "description" },
				{ text: "Goedgekeurd", value: "coordinator_approval" }
			],
			data: [],
			loading: false
		};
	},
	created: function() {
		this.getRows();
	},
	methods: {
		handleClick(id) {
			this.$router.push({
				path: "/schooladmin/student_overtake_class_coordinator/update/" + id
			});
		},
		setStudentOvertakeClass: function() {
			this.$router.push({
				path: "/schooladmin/student_overtake_class_coordinator/new"
			});
		},
		getRows: function() {
			var self = this;
			this.loading = true;
			ax.get("/student_overtake_class/coordinator_all", {
				params: {
					user_id: this.user.id
				}
			})
				.then(function(response) {
					self.data = response.data || [];
					self.loading = false;
				})
				.catch(function() {
					self.loading = false;
				});
		}
	}
};
</script>
